/* Florema · Test de aroma "Elige tus notas" (sección florema-quiz-notas) · oct 2026
   - Juego: 20 notas (las 3 notas oficiales de cada uno de los 8 aromas), me gusta / no (deslizar, botones o flechas), atrás.
   - Puntaje: por aroma = (notas que te gustaron − 1,2 × notas que no) / 3. Gana el mayor; empates: más notas que te gustaron,
     menos descartadas y, al final, el orden TIE (los más vendidos primero).
   - Resultado: foto real, notas con foto, "Tu casa olerá a…", formatos con precio y disponibilidad EN VIVO de /products/<handle>.js,
     cantidad 1/2/3 (2 u −10 %, 3 u −20 % los aplica solo el carro; packs sin ese descuento) y "Agregar al carro" real:
     POST /cart/add.js + window.FloremaCart.refresh() + open().
   - Correo con 10 %: el formulario nativo de Shopify (form 'customer') que trae la sección en Liquid; aquí solo se mueve al resultado,
     se le pone contact[tags]="quiz-aroma,aroma-<ganador>" y se valida. Envío normal (hCaptcha de Shopify activo). Al volver con
     ?customer_posted=true se muestra el código y el resultado otra vez (se guarda en sessionStorage antes de enviar).
   - Analítica: dataLayer / Shopify.analytics.publish si existen: quiz_start, quiz_result, quiz_add_to_cart (y quiz_email_submit). */
(function () {
  'use strict';
  var root = document.querySelector('[data-flq-root]');
  if (!root || root.__flq) return;
  root.__flq = true;

  var CODE = root.getAttribute('data-code') || 'BIENVENIDO-10';
  var FILES = 'https://florema.cl/cdn/shop/files/';
  var SS_KEY = 'flq_state_v1', SS_PEND = 'flq_pending_v1';

  /* ---------------- datos ---------------- */
  /* Los 8 aromas: notas oficiales (3 de "Notas principales"), textos "Tu casa olerá a…" (los mismos de la ficha) y handles reales.
     Ojo con los handles: Tropical vive en handles "uvana…-copia" / "mangolu…-copia"; el auto de Roma es car-essence-sugar-8ml y el de Vitali
     car-essence-fresh-8ml. Se identificaron por TÍTULO y se verificaron contra /products/<handle>.js (18-oct-2026). */
  var ORDEN = ['Bloom', 'Fresh', 'Mangolú', 'Roma', 'Sugar', 'Tropical', 'Uvana', 'Vitali'];
  var TIE = ['Roma', 'Tropical', 'Vitali', 'Sugar', 'Fresh', 'Bloom', 'Mangolú', 'Uvana'];
  var AROMAS = {
    'Bloom': { s: 'bloom', fam: 'Floral', badge: '', notes: [['lavanda', 'Lavanda'], ['pomelo', 'Pomelo'], ['coco', 'Coco']], o: 'calma', w: ['Sereno', 'Luminoso', 'Delicado'],
      f: 'Como un campo de lavanda al atardecer, con un destello fresco de pomelo. Un aroma que calma la casa y te invita a desconectarte.',
      p: 'Para quien busca calma al llegar a casa: dormitorios y rincones de lectura.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__40222.png?v=1771724091',
      h: { dif150: 'bloom-difusor-aromatico-150ml', dif100: 'difusor-aromatico-110ml-bloom', sp250: 'bloom-home-spray-250ml', sp130: 'home-spray-bloom-130ml', auto: 'bloom-car-essence-8ml' } },
    'Fresh': { s: 'fresh', fam: 'Cítrica', badge: '', notes: [['limon', 'Limón de pica'], ['pomelo', 'Pomelo'], ['sandalo', 'Sándalo']], o: 'limpio', w: ['Limpio', 'Vibrante', 'Fresco'],
      f: 'La sensación de una casa recién ventilada: cítricos chispeantes que se asientan en una calidez suave de maderas.',
      p: 'Para quien ama la sensación de limpio: living, cocina y espacios de trabajo.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__40215.png?v=1771724296',
      h: { dif150: 'fresh-difusor-aromatico-150ml', dif100: 'difusor-aromatico-110ml-fresh', sp250: 'home-spray-fresh-250ml', sp130: 'fresh-home-spray-130ml', auto: 'fresh-car-essence-8ml' } },
    'Mangolú': { s: 'mangolu', fam: 'Frutal', badge: '', notes: [['mango', 'Mango'], ['naranja', 'Naranja'], ['ambar', 'Ámbar']], o: 'tarde de verano', w: ['Cálido', 'Soleado', 'Jugoso'],
      f: 'Fruta madura de verano que despierta los sentidos, con un fondo ámbar que abraza al caer la tarde.',
      p: 'Para quien quiere calidez y buena energía en los espacios compartidos.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__34213.png?v=1771724632',
      h: { dif150: 'difusor-aromatico-mangolu-150ml', dif100: 'difusor-aromatico-110ml-mangolu', sp250: 'home-spray-mangolu-250ml', sp130: 'home-spray-mangolu-130ml', auto: 'car-essence-mangolu-8ml' } },
    'Roma': { s: 'roma', fam: 'Dulce', badge: 'Más vendido', notes: [['rosas', 'Rosas'], ['frambuesa', 'Frambuesa'], ['vainilla', 'Vainilla']], o: 'ramo de rosas', w: ['Sofisticado', 'Romántico', 'Elegante'],
      f: 'Un ramo de rosas recién llegado con un toque dulce de frutos rojos. Envuelve el ambiente sin empalagar.',
      p: 'Para quien busca un toque elegante y romántico: living, dormitorio o para regalar.',
      img: 'difusor-roma-150ml-ambiente.jpg?v=1791694478',
      h: { dif150: 'difusor-aromatico-roma-150ml', dif100: 'difusor-aromatico-110ml-roma', sp250: 'home-spray-roma-250ml', sp130: 'home-spray-roma-130ml', auto: 'car-essence-sugar-8ml' } },
    'Sugar': { s: 'sugar', fam: 'Dulce', badge: '', notes: [['arandano', 'Arándano'], ['jazmin', 'Jazmín'], ['pachuli', 'Pachulí']], o: 'tarde de manta y té', w: ['Dulce', 'Envolvente', 'Acogedor'],
      f: 'Frutos azules y flores blancas sobre un fondo profundo. Como una tarde de manta y té en casa.',
      p: 'Para quien quiere un hogar acogedor y dulce, sin empalagar.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__34195.png?v=1771720788',
      h: { dif150: 'sugar-difusor-aromatico-150ml', dif100: 'difusor-aromatico-110ml-sugar', sp250: 'home-spray-sugar-250ml', sp130: 'sugar-home-spray-130ml', auto: 'sugar-car-essence-8ml' } },
    'Tropical': { s: 'tropical', fam: 'Frutal', badge: 'Aroma favorito', notes: [['mango', 'Mango'], ['durazno', 'Durazno'], ['coco', 'Coco']], o: 'verano', w: ['Fresco', 'Jugoso', 'Revitalizante'],
      f: 'Frutas recién cortadas y una brisa de verano. Llena la casa de energía y buen ánimo desde la mañana.',
      p: 'Para quien quiere una casa alegre y con energía desde la mañana.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__40206.png?v=1771721627',
      h: { dif150: 'difusor-aromatico-uvana-150ml-copia', dif100: 'difusor-aromatico-100ml-uvana-copia', sp250: 'home-spray-uvana-250ml-copia', sp130: 'home-spray-mangolu-130ml-copia', auto: 'difusor-de-auto-uvana-8ml-copia' } },
    'Uvana': { s: 'uvana', fam: 'Frutal', badge: '', notes: [['platano', 'Plátano'], ['uva', 'Uva'], ['pina', 'Piña']], o: 'frutera de colores', w: ['Alegre', 'Frutal', 'Divertido'],
      f: 'Una frutera llena de color: dulce, alegre y nada empalagoso. Ideal para espacios con mucha vida.',
      p: 'Para hogares con mucha vida y espacios llenos de color.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__34188.png?v=1771721170',
      h: { dif150: 'difusor-aromatico-uvana-150ml', dif100: 'difusor-aromatico-110ml-uvana', sp250: 'home-spray-uvana-250ml', sp130: 'uvana-home-spray-130ml', auto: 'car-essence-uvana-8ml' } },
    'Vitali': { s: 'vitali', fam: 'Cítrica', badge: '', notes: [['verbena', 'Verbena'], ['limon', 'Limón'], ['bergamota', 'Bergamota']], o: 'mañana fresca', w: ['Revitalizante', 'Verde', 'Fresco'],
      f: 'Hojas recién cortadas con cítricos brillantes. Energía limpia para empezar el día con todo.',
      p: 'Para quien empieza el día con todo: oficinas, home office y cocinas.',
      img: 'freepik__edit-imagetoimage-flux-use-my-uploaded-product-ima__34209.png?v=1771721398',
      h: { dif150: 'difusor-aromatico-vitali-150ml', dif100: 'difusor-aromatico-110ml-vitali', sp250: 'home-spray-vitali-250ml', sp130: 'home-spray-vitali-130ml', auto: 'car-essence-fresh-8ml' } }
  };
  /* Formatos (orden de la lista). pack = variante "Aroma / Aroma" del producto pack; disc = entra en el −10 % / −20 % por cantidad. */
  var FORMATS = [
    { k: 'dif150', n: 'Difusor de varillas 150 ml', d: 'Varillas de madera en frasco ámbar', disc: true, rec: true },
    { k: 'pack150', n: 'Pack difusor 150 ml + home spray 250 ml', d: 'Un frasco de cada uno, mismo aroma', pack: 'pack-difusor-150ml-home-spray-250ml' },
    { k: 'sp250', n: 'Home spray 250 ml', d: 'Se rocía cuando quieres reforzar el ambiente', disc: true },
    { k: 'auto', n: 'Difusor de auto 8 ml', d: 'Para colgar en tu auto', disc: true },
    { k: 'dif100', n: 'Difusor de varillas 100 ml', d: 'Tamaño compacto para espacios chicos', disc: true, extra: true },
    { k: 'sp130', n: 'Home spray 130 ml', d: 'Tamaño chico, fácil de llevar', disc: true, extra: true },
    { k: 'pack100', n: 'Pack difusor 100 ml + home spray 130 ml', d: 'Un frasco de cada uno, mismo aroma', pack: 'pack-difusor-100ml-home-130ml', extra: true }
  ];
  var DISC = { 1: 0, 2: 0.10, 3: 0.20 };
  /* El mazo: cada nota única, con la foto de uno de los aromas que la tienen (fl-nota-<aroma>-<nota>.jpg). Mezcla familias desde el comienzo. */
  var DECK = [
    ['rosas', 'Rosas', 'roma'], ['limon', 'Limón', 'fresh'], ['lavanda', 'Lavanda', 'bloom'], ['mango', 'Mango', 'tropical'],
    ['arandano', 'Arándano', 'sugar'], ['platano', 'Plátano', 'uvana'], ['vainilla', 'Vainilla', 'roma'], ['pomelo', 'Pomelo', 'fresh'],
    ['durazno', 'Durazno', 'tropical'], ['verbena', 'Verbena', 'vitali'], ['jazmin', 'Jazmín', 'sugar'], ['coco', 'Coco', 'tropical'],
    ['sandalo', 'Sándalo', 'fresh'], ['naranja', 'Naranja', 'mangolu'], ['uva', 'Uva', 'uvana'], ['bergamota', 'Bergamota', 'vitali'],
    ['frambuesa', 'Frambuesa', 'roma'], ['ambar', 'Ámbar', 'mangolu'], ['pachuli', 'Pachulí', 'sugar'], ['pina', 'Piña', 'uvana']
  ].map(function (x) { return { k: x[0], n: x[1], s: x[2] }; });
  var NOTE_NAME = {}; DECK.forEach(function (d) { NOTE_NAME[d.k] = d.n; });
  var N = DECK.length;

  /* ---------------- utilidades ---------------- */
  function $(s, r) { return (r || root).querySelector(s); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clp(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function noteImg(slug, key, w) { return FILES + 'fl-nota-' + slug + '-' + key + '.jpg?width=' + (w || 600); }
  function cdn(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function track(name, data) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('flquiz:' + name, { detail: data })); } catch (e) {}
  }
  var reduce = false; try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------------- elementos de la sección ---------------- */
  var stage = $('[data-flq-stage]'), bar = $('[data-flq-bar]'), barEl = bar.parentNode, cnt = $('[data-flq-cnt]'), back = $('[data-flq-back]');
  var toastEl = $('[data-flq-toast]'), liveEl = $('[data-flq-live]');
  var formHome = $('[data-flq-formhome]'), form = $('.flq-form', formHome);
  var tagsInput = form && $('[data-flq-tags]', form), emailInput = form && $('[data-flq-email]', form), errEl = form && $('[data-flq-err]', form);

  /* el encabezado del tema puede ir pegado arriba: la foto del resultado se pega debajo de él */
  function medirEncabezado() {
    var h = 0, e = document.querySelector('.florema-hdr, header.header, .shopify-section-group-header-group');
    try { if (e) { var cs = getComputedStyle(e); if (cs.position === 'sticky' || cs.position === 'fixed') h = Math.round(e.getBoundingClientRect().height); } } catch (x) {}
    root.style.setProperty('--flq-top', (h + 16) + 'px');
  }
  medirEncabezado(); window.addEventListener('resize', medirEncabezado);

  /* ---------------- estado ---------------- */
  var S = { idx: 0, yes: [], no: [], hist: [], busy: false, ranking: null, cur: null, fmt: 'dif150', qty: 1, more: false, added: false, adding: false, addMsg: '',
            mail: 'form', skipped: false, startedSent: false, screen: 'intro' };
  var PROD = {};   // handle -> producto (JSON de /products/<handle>.js) | false si falló
  var LOADING = {};

  /* el formulario de Shopify vive dentro del resultado: antes de repintar se devuelve a su casa oculta para no perderlo */
  function stash() { if (form && formHome && !formHome.contains(form)) formHome.appendChild(form); }
  function setStage(html) { stash(); stage.innerHTML = html; }
  function liveSay(t) { if (liveEl) liveEl.textContent = t; }
  function setHead(n, total, showBack) {
    var pct = total ? Math.round(n / total * 100) : 0;
    bar.style.width = pct + '%'; barEl.setAttribute('aria-valuenow', pct);
    cnt.textContent = total && n > 0 && n <= total ? (n + ' / ' + total) : '';
    back.hidden = !showBack;
  }
  function toast(msg) { toastEl.textContent = msg; toastEl.classList.add('on'); clearTimeout(toast._t); toast._t = setTimeout(function () { toastEl.classList.remove('on'); }, 3200); }

  /* ---------------- puntaje ---------------- */
  function rankAromas(yes, no) {
    var rows = ORDEN.map(function (id) {
      var ns = AROMAS[id].notes.map(function (n) { return n[0]; });
      var L = ns.filter(function (k) { return yes.indexOf(k) > -1; }), D = ns.filter(function (k) { return no.indexOf(k) > -1; });
      var aff = Math.max(0, (L.length - 1.2 * D.length) / ns.length);
      var pct = Math.min(99, Math.round(100 * Math.max(aff, L.length ? 0.15 : 0)));
      return { id: id, L: L, D: D, aff: aff, pct: pct, tie: TIE.indexOf(id) };
    });
    rows.sort(function (a, b) { return b.aff - a.aff || b.L.length - a.L.length || a.D.length - b.D.length || a.tie - b.tie; });
    return rows;
  }
  function noteLabel(id, key) { var n = AROMAS[id].notes.filter(function (x) { return x[0] === key; })[0]; return n ? n[1] : (NOTE_NAME[key] || key); }

  /* ---------------- productos en vivo ---------------- */
  function getProduct(handle) {
    if (PROD[handle]) return Promise.resolve(PROD[handle]);
    if (LOADING[handle]) return LOADING[handle];
    LOADING[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) { PROD[handle] = j; delete LOADING[handle]; return j; })
      .catch(function () { PROD[handle] = false; delete LOADING[handle]; setTimeout(function () { if (PROD[handle] === false) delete PROD[handle]; }, 15000); return false; });
    return LOADING[handle];
  }
  function handleOf(id, fmtKey) {
    var f = FORMATS.filter(function (x) { return x.k === fmtKey; })[0];
    return f.pack || AROMAS[id].h[fmtKey];
  }
  function variantOf(id, fmtKey) {
    var f = FORMATS.filter(function (x) { return x.k === fmtKey; })[0], p = PROD[handleOf(id, fmtKey)];
    if (!p) return null;
    if (f.pack) {
      var vs = p.variants.filter(function (v) { return v.option1 === id && v.option2 === id; });
      return vs[0] || null;
    }
    return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0] || null;
  }
  /* info de un formato para el aroma: {state:'load'|'err'|'out'|'ok', unit, cmp, v, img} (precios en pesos; el .js trae centavos) */
  function info(id, fmtKey) {
    var h = handleOf(id, fmtKey), p = PROD[h];
    if (p === undefined) return { state: 'load' };
    if (p === false) return { state: 'err' };
    var v = variantOf(id, fmtKey);
    if (!v) return { state: 'err' };
    var unit = v.price / 100, cmp = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price / 100 : 0;
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    return { state: v.available ? 'ok' : 'out', unit: unit, cmp: cmp, v: v, img: img, p: p };
  }
  function fmtDef(k) { return FORMATS.filter(function (x) { return x.k === k; })[0]; }
  function precargar(id) {
    var hs = FORMATS.map(function (f) { return handleOf(id, f.k); });
    return Promise.all(hs.map(getProduct)).then(function () { if (S.screen === 'result' && S.cur === id) pintarCompra(); });
  }

  /* ---------------- pantallas ---------------- */
  function intro() {
    precargaMazo(0, 7);
    S.screen = 'intro'; S.idx = 0; S.yes = []; S.no = []; S.hist = []; S.ranking = null;
    setHead(0, N, false);
    var T = root.getAttribute('data-intro-title') || 'Elige tus notas';
    var X = root.getAttribute('data-intro-text') || 'Te mostramos las notas con las que hacemos nuestros aromas, una por una. Desliza a la derecha las que te gustan y a la izquierda las que no. Con eso encontramos tu aroma.';
    var mos = ['roma-rosas', 'fresh-limon', 'bloom-lavanda', 'tropical-mango', 'roma-vainilla', 'sugar-arandano'].map(function (f) { return '<img src="' + FILES + 'fl-nota-' + f + '.jpg?width=600" alt="" loading="eager" decoding="async">'; }).join('');
    setStage('<section class="flq-intro flq-scr"><div class="flq-mosaic" aria-hidden="true">' + mos + '</div>'
      + '<div><span class="flq-mono">Test de aroma · 1 minuto</span><h1>' + esc(T) + '</h1>'
      + '<p class="flq-lead">' + esc(X) + '</p>'
      + '<button class="flq-btn" type="button" data-act="go">Empezar</button>'
      + '<div class="flq-meta"><span>' + N + ' notas</span><span>Sin registro</span><span>Resultado al tiro</span></div></div></section>');
  }
  function cardHtml(i, pos) {
    var d = DECK[i];
    return '<div class="flq-card p' + pos + '" data-k="' + d.k + '"' + (pos ? ' aria-hidden="true"' : '') + '><span class="flq-stamp yes">Me gusta</span><span class="flq-stamp no">No</span>'
      + '<span class="flq-ph" data-name="' + esc(d.n) + '"><img src="' + noteImg(d.s, d.k) + '" alt="' + esc(d.n) + '" draggable="false" decoding="async"></span>'
      + '<span class="flq-nm">' + esc(d.n) + '</span><span class="flq-mono">Nota ' + (i + 1) + ' de ' + N + '</span></div>';
  }
  /* precarga las próximas fotos para que no se vean a medio cargar al deslizar */
  function precargaMazo(desde, hasta) { for (var i = desde; i < hasta && i < N; i++) { try { var im = new Image(); im.src = noteImg(DECK[i].s, DECK[i].k); } catch (e) {} } }
  function play() {
    S.screen = 'deck';
    precargaMazo(S.idx + 3, S.idx + 7);
    setHead(S.idx, N, S.idx > 0);
    if (S.idx >= N) return finish();
    var cards = '';
    for (var p = 2; p >= 0; p--) if (S.idx + p < N) cards += cardHtml(S.idx + p, p);
    if (!$('.flq-deck')) {
      setStage('<section class="flq-scr flq-deckwrap"><p class="flq-k flq-mono" data-flq-k></p><h2 class="flq-t" tabindex="-1">¿Te gusta esta nota?</h2><p class="flq-s">Desliza o usa los botones.</p>'
        + '<div class="flq-deck" data-flq-deck></div>'
        + '<div class="flq-acts"><button class="flq-rb" type="button" data-act="no" aria-label="No me gusta"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
        + '<button class="flq-rb y" type="button" data-act="yes" aria-label="Me gusta"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.2C1.6 7.7 4 4.5 7.2 4.5c1.9 0 3.6 1 4.8 2.7 1.2-1.7 2.9-2.7 4.8-2.7 3.2 0 5.6 3.2 4.4 6.8-1.700 4.600-9.200 9.200-9.200 9.200z"/></svg></button></div>'
        + '<div class="flq-lab2"><span>No</span><span>Me gusta</span></div>'
        + '<div class="flq-tray" data-flq-tray aria-label="Tus notas favoritas"></div><div class="flq-early" data-flq-early></div></section>');
    }
    $('[data-flq-deck]').innerHTML = cards;
    $('[data-flq-k]').textContent = 'Nota ' + (S.idx + 1) + ' de ' + N;
    liveSay('Nota ' + (S.idx + 1) + ' de ' + N + ': ' + DECK[S.idx].n);
    var tray = $('[data-flq-tray]');
    tray.innerHTML = S.yes.length ? '<span class="flq-lbl">Tus favoritas</span>' + S.yes.map(function (k) {
      var d = DECK.filter(function (x) { return x.k === k; })[0];
      return '<img src="' + noteImg(d.s, d.k) + '" alt="' + esc(d.n) + '" title="' + esc(d.n) + '" width="34" height="34">';
    }).join('') : '<span class="flq-lbl">Aquí irán tus notas favoritas</span>';
    $('[data-flq-early]').innerHTML = (S.idx >= 10 && S.yes.length) ? '<button class="flq-btn flq-btn--ghost" type="button" data-act="fin" style="min-height:44px;padding:10px 18px;font-size:11px">Ya sé cuál es: ver mi aroma</button>' : '';
    bindDrag($('.flq-card.p0'));
  }
  function fly(dir) {
    if (S.busy || S.screen !== 'deck') return;
    var c = $('.flq-card.p0'); if (!c) return;
    S.busy = true; c.classList.remove('drag');
    c.style.transform = 'translateX(' + (dir * 140) + '%) rotate(' + (dir * 18) + 'deg)'; c.style.opacity = '0';
    var k = DECK[S.idx].k; S.hist.push({ k: k, dir: dir }); (dir > 0 ? S.yes : S.no).push(k);
    setTimeout(function () { S.busy = false; S.idx++; play(); }, reduce ? 0 : 240);
  }
  function bindDrag(c) {
    if (!c) return;
    var sx = 0, dx = 0, on = false, sy = $('.flq-stamp.yes', c), sn = $('.flq-stamp.no', c);
    c.addEventListener('pointerdown', function (e) { if (S.busy) return; on = true; sx = e.clientX; dx = 0; try { c.setPointerCapture(e.pointerId); } catch (x) {} c.classList.add('drag'); });
    c.addEventListener('pointermove', function (e) {
      if (!on) return; dx = e.clientX - sx;
      c.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 18) + 'deg)';
      var a = Math.min(1, Math.abs(dx) / 90); sy.style.opacity = dx > 0 ? a : 0; sn.style.opacity = dx < 0 ? a : 0;
    });
    function end() {
      if (!on) return; on = false; c.classList.remove('drag');
      if (Math.abs(dx) > 90) fly(dx > 0 ? 1 : -1); else { c.style.transform = ''; sy.style.opacity = 0; sn.style.opacity = 0; }
    }
    c.addEventListener('pointerup', end); c.addEventListener('pointercancel', end);
  }
  document.addEventListener('keydown', function (e) {
    if (S.screen !== 'deck' || !$('[data-flq-deck]')) return;
    var t = e.target && e.target.tagName; if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
    if (e.key === 'ArrowRight') { e.preventDefault(); fly(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); fly(-1); }
  });

  function finish() {
    if (!S.yes.length) {
      S.screen = 'empty'; setHead(0, N, false);
      setStage('<section class="flq-scr flq-empty"><h2 class="flq-t">Ninguna nota te convenció</h2><p class="flq-s">Para encontrar tu aroma necesitamos que elijas al menos una nota que te guste. Prueba otra vez.</p><button class="flq-btn" type="button" data-act="again">Volver a empezar</button></section>');
      return;
    }
    S.screen = 'loading'; setHead(N, N, false);
    S.ranking = rankAromas(S.yes, S.no); S.cur = S.ranking[0].id;
    setStage('<div class="flq-load flq-scr" role="status"><div><span class="flq-ring"></span><p>Mezclando tus notas…</p><p class="flq-mono">Buscando tu aroma entre los 8</p></div></div>');
    precargar(S.cur);
    setTimeout(function () { mostrarResultado(true); }, reduce ? 0 : 1100);
  }

  /* ---------------- resultado ---------------- */
  function persist() {
    ssSet(SS_KEY, JSON.stringify({ y: S.yes, n: S.no, i: S.idx, f: S.fmt, q: S.qty, c: S.cur, t: Date.now() }));
  }
  function mostrarResultado(first) {
    if (S.screen !== 'loading') return;
    S.screen = 'result'; setHead(N, N, true);
    S.fmt = 'dif150'; S.qty = 1; S.more = false; S.added = false; S.adding = false; S.addMsg = '';
    persist();
    track('quiz_result', { aroma: S.ranking[0].id, match_pct: S.ranking[0].pct, liked_notes: S.yes.join(','), disliked_notes: S.no.join(','), notes_seen: S.idx });
    drawResult(first);
  }
  function item(id) { return S.ranking.filter(function (r) { return r.id === id; })[0]; }

  function drawResult(scrollTop) {
    var id = S.cur, a = AROMAS[id], it = item(id), liked = S.yes, winner = S.ranking[0].id;
    var alts = S.ranking.filter(function (r) { return r.id !== id; }).slice(0, 2);
    var off = Math.round(226 * (1 - it.pct / 100));
    var tot = a.notes.length;
    var match = it.L.length
      ? 'Te gustaron ' + it.L.length + ' de sus ' + tot + ' notas: ' + it.L.map(function (k) { return noteLabel(id, k).toLowerCase(); }).join(', ') + '.'
      : 'No marcaste ninguna de sus notas; mira las otras opciones.';
    var hero = (PROD[a.h.dif150] && PROD[a.h.dif150].featured_image) ? cdn(PROD[a.h.dif150].featured_image, 1000) : cdn(FILES + a.img, 1000);
    setStage('<section class="flq-res flq-scr" aria-labelledby="flq-rt">'
      + '<p class="flq-k flq-mono">Tu resultado</p>'
      + '<div class="flq-res-top">'
      + '<div class="flq-res-ph"><img class="main" data-flq-hero src="' + esc(hero) + '" alt="Difusor ' + esc(id) + ' de Florema" decoding="async">'
      + '<span class="bd">' + (id === winner ? 'Tu aroma' : 'Otra opción para ti') + '</span>'
      + '<img class="pk" data-flq-pk alt="" hidden></div>'
      + '<div class="flq-res-in">'
      + '<span class="flq-fam">' + esc(a.fam) + (a.badge ? ' · ' + esc(a.badge) : '') + '</span>'
      + '<h2 class="flq-rt" id="flq-rt">' + esc(id) + '</h2>'
      + '<div class="flq-match"><div class="flq-rg"><svg viewBox="0 0 80 80" aria-hidden="true"><circle class="b" cx="40" cy="40" r="36"/><circle class="f" cx="40" cy="40" r="36" data-off="' + off + '"/></svg><b>' + it.pct + '<small>%</small></b></div>'
      + '<p><b>Coincidencia con tus respuestas</b>' + esc(match) + '</p></div>'
      + '<div class="flq-notas" aria-label="Notas de ' + esc(id) + '">' + a.notes.map(function (n) {
          var lk = liked.indexOf(n[0]) > -1;
          return '<span class="flq-nt' + (lk ? ' liked' : '') + '"><img src="' + noteImg(a.s, n[0]) + '" alt="" width="44" height="44" data-nm="' + esc(n[1]) + '">' + esc(n[1]) + (lk ? ' <span class="hrt" aria-label="te gustó">♥</span>' : '') + '</span>';
        }).join('') + '</div>'
      + '<div class="flq-casa"><b>Tu casa olerá a ' + esc(a.o) + ':</b><p><span class="flq-sw">' + a.w.map(function (w) { return '<i>' + esc(w) + '</i>'; }).join('') + '</span>' + esc(a.f) + '</p>'
      + '<p class="para"><b>¿Para quién es?</b> ' + esc(a.p) + '</p></div>'
      + (S.yes.length ? '<div class="flq-resp" aria-label="Tus respuestas"><span>Te gustaron: ' + S.yes.map(function (k) { return esc(NOTE_NAME[k]); }).join(', ') + '</span></div>' : '')
      + '<div class="flq-buy" data-flq-buy></div>'
      + '<div class="flq-save" data-flq-save></div>'
      + '</div></div>'
      + '<div class="flq-sec"><h3><span>También te podrían gustar</span><span>Toca para verlos</span></h3><div class="flq-alts">' + alts.map(function (r) {
          var b = AROMAS[r.id];
          return '<button type="button" class="flq-alt" data-alt="' + esc(r.id) + '"><img src="' + esc(cdn(FILES + b.img, 300)) + '" alt="" loading="lazy" decoding="async"><span><span class="n">' + esc(r.id) + '</span><span class="f">' + esc(b.fam) + '</span><span class="nn">' + esc(b.notes.map(function (n) { return n[1]; }).join(' · ')) + '</span></span><span class="pc">' + (r.pct > 0 ? r.pct + '<small>%</small>' : '') + '</span></button>';
        }).join('') + '</div></div>'
      + '<div class="flq-again"><button type="button" class="flq-btn flq-btn--ghost" data-act="again">Repetir el test</button></div>'
      + '</section>');
    var f = $('.flq-rg .f'); requestAnimationFrame(function () { requestAnimationFrame(function () { f.style.strokeDashoffset = f.getAttribute('data-off'); }); });
    pintarCompra(); pintarCorreo();
    if (scrollTop) { var top = stage.getBoundingClientRect().top + window.pageYOffset - 70; window.scrollTo(0, Math.max(0, top)); }
    liveSay('Tu aroma es ' + id);
    precargar(id);
  }

  function pintarCompra() {
    var box = $('[data-flq-buy]'); if (!box) return;
    var id = S.cur, a = AROMAS[id];
    var infos = {}; FORMATS.forEach(function (f) { infos[f.k] = info(id, f.k); });
    var todos = FORMATS.every(function (f) { return infos[f.k].state === 'err'; });
    /* si el formato elegido no se puede comprar, pasar al primero que sí */
    if (infos[S.fmt].state === 'out' || infos[S.fmt].state === 'err') {
      var ok = FORMATS.filter(function (f) { return infos[f.k].state === 'ok'; })[0];
      if (ok) S.fmt = ok.k;
    }
    if (fmtDef(S.fmt).extra) S.more = true;
    var cur = fmtDef(S.fmt), ci = infos[S.fmt];
    var disc = cur.disc ? DISC[S.qty] : 0;
    var unit = ci.state === 'ok' ? ci.unit : 0;
    var totV = Math.round(unit * S.qty * (1 - disc));
    var strike = ci.state === 'ok' ? (ci.cmp ? ci.cmp : unit) * S.qty : 0;
    var save = strike - totV;
    var dq3 = ci.state === 'ok' && cur.disc ? Math.round(unit * 3 * 0.2) : 0;

    function row(f) {
      var i = infos[f.k], on = f.k === S.fmt, dis = i.state === 'out' || i.state === 'err';
      var price = i.state === 'load' ? '<span class="flq-sk"></span>' : i.state === 'ok' ? clp(i.unit) + (i.cmp ? '<s>' + clp(i.cmp) + '</s>' : '') : (i.state === 'out' ? 'Agotado' : 'No disponible');
      var thumb = i.img ? '<img src="' + esc(cdn(i.img, 120)) + '" alt="" width="48" height="48" loading="lazy" decoding="async">' : '<span class="ph1"></span>';
      var rec = f.rec && !dis ? '<span class="rec">Recomendado</span>' : '';
      return '<button type="button" class="flq-fm" role="radio" aria-checked="' + on + '" data-fm="' + f.k + '"' + (dis ? ' disabled' : '') + '>' + rec + thumb
        + '<span><span class="n">' + esc(f.n) + '</span><span class="d">' + esc(f.d) + (f.pack && i.state === 'ok' && i.cmp ? ' · ahorras ' + clp(i.cmp - i.unit) : '') + '</span></span><span class="p">' + price + '</span></button>';
    }
    var rows = FORMATS.filter(function (f) { return !f.extra || S.more; }).map(row).join('');
    var hidden = FORMATS.filter(function (f) { return f.extra; }).length;
    var totalHtml, btnLabel, btnDis = ci.state !== 'ok' || S.adding;
    if (ci.state === 'ok') {
      totalHtml = '<div class="flq-tot"><div><span class="pr">' + clp(totV) + '</span>' + (save > 0 ? '<s>' + clp(strike) + '</s>' : '') + '</div>' + (save > 0 ? '<span class="sv">Ahorras ' + clp(save) + '</span>' : '') + '</div>';
    } else {
      totalHtml = '<div class="flq-tot"><div><span class="pr">' + (ci.state === 'load' ? '<span class="flq-sk" style="width:110px;height:24px"></span>' : '—') + '</span></div></div>';
    }
    btnLabel = S.adding ? 'Agregando…' : S.added ? 'Agregado ✓ · Ver carro' : 'Agregar al carro · ' + esc(id);
    var qtyHtml = [1, 2, 3].map(function (n) {
      var lab = n === 1 ? 'unidad' : (cur.disc ? n + ' u · −' + Math.round(DISC[n] * 100) + '%' : n + ' u');
      return '<button type="button" class="flq-q" role="radio" aria-checked="' + (n === S.qty) + '" data-q="' + n + '">' + (n === 3 && cur.disc ? '<em>Recomendado</em>' : '') + '<b>' + n + '</b><span>' + lab + '</span></button>';
    }).join('');
    var mini = !cur.disc ? 'Los packs ya vienen con precio especial: no suman el descuento por cantidad.'
      : (S.qty < 3 && dq3 ? 'Con <b>3 unidades pagas −20%</b>: ahorras ' + clp(dq3) + ' en este formato.' : (S.qty === 3 ? 'Aplicado: <b>3 unidades, −20%</b>.' : ''));
    box.innerHTML = '<h3><span>Cómo lo quieres</span></h3>'
      + (todos ? '<p class="flq-pricemsg">No pudimos leer los precios ahora. Recarga la página o míralo en la tienda.</p>' : '')
      + '<div class="flq-fm-row" role="radiogroup" aria-label="Formato">' + rows + '</div>'
      + (!S.more ? '<button type="button" class="flq-more" data-more>Ver ' + hidden + ' formatos más (100 ml, 130 ml y pack chico)</button>' : '')
      + '<h3><span>Cuántos</span><span>' + (cur.disc ? 'Llevando más, pagas menos' : '') + '</span></h3>'
      + '<div class="flq-qty" role="radiogroup" aria-label="Cantidad">' + qtyHtml + '</div>'
      + totalHtml
      + '<span class="flq-addmsg" role="alert">' + esc(S.addMsg) + '</span>'
      + '<button type="button" class="flq-btn flq-btn--full' + (S.added ? ' flq-btn--ok' : '') + '" data-add' + (btnDis ? ' disabled' : '') + '>' + btnLabel + '</button>'
      + '<p class="flq-mini">' + mini + (cur.disc ? ' El descuento se aplica solo en el carro (también mezclando aromas del mismo formato).' : '') + '</p>'
      + '<div class="flq-trust"><span>Envío gratis sobre $50.000</span><span>Garantía de 30 días para cambio de aroma</span></div>';
    /* foto del formato elegido, chiquita sobre la foto grande */
    var pk = $('[data-flq-pk]');
    if (pk) { var src = ci.state === 'ok' && ci.img ? cdn(ci.img, 200) : ''; if (src) { pk.src = src; pk.hidden = false; } else pk.hidden = true; }
  }

  /* ---------------- correo con 10 % (formulario nativo de Shopify) ---------------- */
  function pintarCorreo() {
    var box = $('[data-flq-save]'); if (!box) return;
    stash();
    if (S.skipped && S.mail !== 'done') { box.hidden = true; return; }
    box.hidden = false;
    if (S.mail === 'done') {
      box.innerHTML = '<div class="flq-done"><span class="ttl">Listo. Tu resultado quedó guardado.</span><p style="margin:0">Tu código para la primera compra:</p><span class="flq-code" data-flq-code>' + esc(CODE) + '</span>'
        + '<button type="button" class="flq-copy" data-copy>Copiar código</button><p style="margin:4px 0 0;font-size:13px">Úsalo al pagar, en el campo de código de descuento.</p></div>';
      return;
    }
    box.innerHTML = '<span class="ttl">Guarda tu resultado y recibe 10% en tu primera compra</span><p>Te dejamos tu resultado en el correo y el código ' + esc(CODE) + '. Es opcional: puedes comprar sin dejarlo.</p><div data-flq-slot></div>'
      + '<button type="button" class="flq-skip" data-skip>Seguir sin descuento</button>';
    var slot = $('[data-flq-slot]', box);
    if (form && slot) { slot.appendChild(form); if (tagsInput) tagsInput.value = 'quiz-aroma,aroma-' + AROMAS[S.ranking[0].id].s; if (errEl) errEl.textContent = ''; }
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      var v = (emailInput.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { e.preventDefault(); errEl.textContent = 'Revisa tu correo, parece incompleto.'; emailInput.focus(); return; }
      errEl.textContent = '';
      if (S.ranking) tagsInput.value = 'quiz-aroma,aroma-' + AROMAS[S.ranking[0].id].s;
      persist(); ssSet(SS_PEND, '1');
      track('quiz_email_submit', { aroma: S.ranking ? S.ranking[0].id : '' });
      /* sin preventDefault: envío normal de Shopify (hCaptcha activo). Al volver trae ?customer_posted=true */
    });
  }

  /* ---------------- agregar al carro ---------------- */
  function agregar() {
    if (S.adding) return;
    var id = S.cur, ci = info(id, S.fmt);
    if (ci.state !== 'ok') return;
    if (S.added) { abrirCarro(); return; }
    S.adding = true; S.addMsg = ''; pintarCompra();
    var vid = ci.v.id, qty = S.qty, fk = S.fmt;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: qty }] }) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j && (j.description || j.message) || 'No se pudo agregar'); }, function () { throw new Error('No se pudo agregar'); });
        return r.json();
      })
      .then(function () {
        S.adding = false; S.added = true; S.addMsg = '';
        track('quiz_add_to_cart', { aroma: id, format: fk, variant_id: vid, quantity: qty, value: Math.round(ci.unit * qty), currency: 'CLP', match_pct: item(id).pct });
        pintarCompra();
        abrirCarro();
      })
      .catch(function (err) {
        S.adding = false; S.added = false; S.addMsg = (err && err.message) ? err.message : 'No se pudo agregar. Inténtalo de nuevo.'; pintarCompra();
      });
  }
  function abrirCarro() {
    var C = window.FloremaCart;
    if (C && typeof C.refresh === 'function') {
      Promise.resolve(C.refresh()).then(function () { if (typeof C.open === 'function') C.open(); }).catch(function () { if (typeof C.open === 'function') C.open(); });
    } else { window.location.href = '/cart'; }
  }

  /* ---------------- eventos ---------------- */
  function refoco(sel) { var e = $(sel); if (e && e.focus) { try { e.focus({ preventScroll: true }); } catch (x) {} } }
  function reiniciar() { ssSet(SS_KEY, null); ssSet(SS_PEND, null); S.mail = 'form'; S.skipped = false; intro(); window.scrollTo(0, 0); }
  function empezar() { if (!S.startedSent) { S.startedSent = true; track('quiz_start', {}); } S.idx = 0; S.yes = []; S.no = []; S.hist = []; play();
    // en celular la portada del test es más alta que la tarjeta: volver arriba para ver la pregunta
    var top = stage.getBoundingClientRect().top + window.pageYOffset - 70; if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top)); }
  function atras() {
    if (S.busy || !S.hist.length) return;
    if (S.screen === 'deck' || S.screen === 'result' || S.screen === 'loading') {
      var h = S.hist.pop(); (h.dir > 0 ? S.yes : S.no).pop(); S.idx = Math.min(S.idx, N) - 1; if (S.idx < 0) S.idx = 0;
      S.ranking = null; play();
    }
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act],[data-fm],[data-q],[data-alt],[data-add],[data-more],[data-skip],[data-copy],[data-flq-back]'); if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-flq-back')) { atras(); return; }
    var act = t.getAttribute('data-act');
    if (act === 'go') empezar();
    else if (act === 'yes') fly(1);
    else if (act === 'no') fly(-1);
    else if (act === 'fin') finish();
    else if (act === 'again') reiniciar();
    else if (t.hasAttribute('data-fm')) { S.fmt = t.getAttribute('data-fm'); S.added = false; S.addMsg = ''; pintarCompra(); persist(); refoco('[data-fm="' + S.fmt + '"]'); }
    else if (t.hasAttribute('data-q')) { S.qty = +t.getAttribute('data-q'); S.added = false; S.addMsg = ''; pintarCompra(); refoco('[data-q="' + S.qty + '"]'); }
    else if (t.hasAttribute('data-alt')) { S.cur = t.getAttribute('data-alt'); S.fmt = 'dif150'; S.qty = 1; S.added = false; S.addMsg = ''; S.more = false; drawResult(true); }
    else if (t.hasAttribute('data-add')) agregar();
    else if (t.hasAttribute('data-more')) { S.more = true; pintarCompra(); }
    else if (t.hasAttribute('data-skip')) { S.skipped = true; pintarCorreo(); }
    else if (t.hasAttribute('data-copy')) {
      var done = function () { t.textContent = 'Copiado ✓'; };
      try { navigator.clipboard.writeText(CODE).then(done, function () { toast('Copia el código: ' + CODE); }); } catch (x) { toast('Copia el código: ' + CODE); }
    }
  });
  /* si una foto no carga (404): cuadro crema con el nombre, sin íconos rotos */
  stage.addEventListener('error', function (e) {
    var im = e.target; if (!im || im.tagName !== 'IMG') return;
    var ph = im.closest('.flq-ph');
    if (ph) { ph.classList.add('noimg'); im.style.display = 'none'; return; }
    var nt = im.closest('.flq-nt');
    if (nt) { var nm = im.getAttribute('data-nm') || ''; var s = document.createElement('span'); s.className = 'ph0'; s.textContent = nm.charAt(0); im.replaceWith(s); return; }
    if (im.closest('.flq-tray')) im.style.display = 'none';
  }, true);

  /* ---------------- arranque ---------------- */
  function restaurar() {
    var st = null; try { st = JSON.parse(ssGet(SS_KEY) || 'null'); } catch (e) { st = null; }
    if (!st || !st.y || !st.y.length) return false;
    S.yes = st.y.filter(function (k) { return NOTE_NAME[k]; }); S.no = (st.n || []).filter(function (k) { return NOTE_NAME[k]; }); S.idx = Math.min(st.i || N, N);
    S.hist = S.yes.map(function (k) { return { k: k, dir: 1 }; }).concat(S.no.map(function (k) { return { k: k, dir: -1 }; }));
    S.ranking = rankAromas(S.yes, S.no); S.cur = st.c && AROMAS[st.c] ? st.c : S.ranking[0].id;
    return true;
  }
  var volvio = /[?&]customer_posted=true(&|$)/.test(location.search);
  if (volvio && (ssGet(SS_PEND) || /[?&]contact(%5B|\[)tags(%5D|\])=quiz-aroma/i.test(location.search))) {
    ssSet(SS_PEND, null);
    S.mail = 'done';
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    if (restaurar()) {
      S.screen = 'result'; setHead(N, N, true);
      S.fmt = 'dif150'; S.qty = 1;
      drawResult(true);
      track('quiz_result', { aroma: S.ranking[0].id, match_pct: S.ranking[0].pct, restored: true });
    } else {
      S.screen = 'done';
      setHead(0, N, false);
      setStage('<section class="flq-scr flq-empty"><h2 class="flq-t">Listo, ya estás en la lista</h2><p class="flq-s">Tu código para la primera compra:</p><p style="text-align:center;margin-bottom:16px"><span class="flq-code" data-flq-code>' + esc(CODE) + '</span></p><p class="flq-s">Úsalo al pagar, en el campo de código de descuento.</p><button class="flq-btn" type="button" data-act="again">Hacer el test de aroma</button></section>');
    }
  } else {
    intro();
  }
  /* con ?customer_posted=true pero sin que viniera de este formulario (p. ej. otro formulario del tema), se ignora y se muestra el inicio */

  window.FloremaQuiz = { state: S, rank: rankAromas, aromas: AROMAS, formats: FORMATS, deck: DECK };
})();
